import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { XCircleIcon } from '@heroicons/react/solid'
import ButtonPrevious from '../UI/ButtonPrevious'

class SubscribeStepIdentity extends Component {
	constructor(props) {
		super(props)
		this.activated_btn_color = "#" + this.props.theme.color1
		this.deactivated_btn_color = "#A3A3A3"
		this.state = {
			lastname: '',
			firstname: '',
			day: '',
			month: '',
			year: '',
			error: null,
			loading: false
		}
	}

	_t = () => this.props.lang_assets.subscribe.step_identity

	isFormValid = () => {
		const { lastname, firstname } = this.state
		return lastname.trim().length >= 2 &&
			firstname.trim().length >= 2
	}

	handleSubmit = (event) => {
		event.preventDefault()
		const { lastname, firstname, day, month, year } = this.state
		if (!this.isFormValid())
		{
			this.setState({ error: this._t().error_fields })
			return
		}
		const allBirthdayFilled = day.length >= 1 && month.length >= 1 && year.length === 4
		const birthday = allBirthdayFilled ? (day.padStart(2, '0') + '/' + month.padStart(2, '0') + '/' + year) : null
		this.setState({ loading: true, error: null })
		this.props.postFindClientByIdentity(lastname.trim(), firstname.trim(), birthday)
		.then(result => {
			this.setState({ loading: false })
			this.props.validateStepIdentity(result, { lastname: lastname.trim(), firstname: firstname.trim(), birthday })
		})
		.catch(err => {
			this.setState({ loading: false, error: this._t().error_generic })
			console.log(err)
		})
	}

	render() {
		const t = this._t()
		const themeColor = '#' + this.props.theme.color1
		const btnColor = this.isFormValid() ? this.activated_btn_color : this.deactivated_btn_color

		return (
			<div>
				<ButtonPrevious
					theme={this.props.theme}
					handlePreviousBtn={this.props.handlePreviousBtn}
				/>
				<div style={{ backgroundColor: themeColor }} className="h-52 z-0 px-8 text-center">
					<p className="text-2xl text-white pt-14 mt-0">{t.header_title}</p>
					<h1 className="text-3xl text-white font-semibold m-0 pt-2">{t.header_subtitle}</h1>
				</div>
				<div className="rounded-t-3xl z-10" style={{ backgroundColor: "#ffffff", marginTop: "-2rem" }}>
					<div className="px-10 pt-16 pb-10">
						<h2 className="text-2xl text-gray-400 mb-8">
							<span className="text-gray-700 font-semibold">{t.form_title}</span> {t.form_subtitle}
						</h2>
						<form onSubmit={this.handleSubmit}>
							<div className="mb-6">
								<label className="block text-sm font-medium text-gray-500 mb-1">{t.lastname}</label>
								<div className="border-b border-gray-300 focus-within:border-indigo-600">
									<input
										className="block pl-0 w-full border-0 border-transparent text-gray-700 focus:ring-0 text-xl"
										type="text"
										value={this.state.lastname}
										onChange={(e) => this.setState({ lastname: e.target.value, error: null })}
										autoCapitalize="words"
									/>
								</div>
							</div>
							<div className="mb-6">
								<label className="block text-sm font-medium text-gray-500 mb-1">{t.firstname}</label>
								<div className="border-b border-gray-300 focus-within:border-indigo-600">
									<input
										className="block pl-0 w-full border-0 border-transparent text-gray-700 focus:ring-0 text-xl"
										type="text"
										value={this.state.firstname}
										onChange={(e) => this.setState({ firstname: e.target.value, error: null })}
										autoCapitalize="words"
									/>
								</div>
							</div>
							<div className="mb-8">
								<label className="block text-sm font-medium text-gray-500 mb-1">{t.birthday} <span className="font-normal">{t.optional}</span></label>
								<div className="flex gap-3">
									<div className="border-b border-gray-300 focus-within:border-indigo-600" style={{ width: '20%' }}>
										<input
											className="block pl-0 w-full border-0 border-transparent text-gray-700 focus:ring-0 text-xl text-center"
											type="number"
											placeholder="JJ"
											min="1" max="31"
											value={this.state.day}
											onChange={(e) => this.setState({ day: e.target.value, error: null })}
										/>
									</div>
									<div className="border-b border-gray-300 focus-within:border-indigo-600" style={{ width: '20%' }}>
										<input
											className="block pl-0 w-full border-0 border-transparent text-gray-700 focus:ring-0 text-xl text-center"
											type="number"
											placeholder="MM"
											min="1" max="12"
											value={this.state.month}
											onChange={(e) => this.setState({ month: e.target.value, error: null })}
										/>
									</div>
									<div className="border-b border-gray-300 focus-within:border-indigo-600" style={{ width: '40%' }}>
										<input
											className="block pl-0 w-full border-0 border-transparent text-gray-700 focus:ring-0 text-xl text-center"
											type="number"
											placeholder="AAAA"
											min="1900" max="2099"
											value={this.state.year}
											onChange={(e) => this.setState({ year: e.target.value, error: null })}
										/>
									</div>
								</div>
							</div>
							{this.state.error && (
								<div className="rounded-md bg-red-50 p-4 mb-4">
									<div className="flex">
										<div className="flex-shrink-0">
											<XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
										</div>
										<div className="ml-3">
											<h3 className="text-sm font-medium text-red-800">{this.state.error}</h3>
										</div>
									</div>
								</div>
							)}
							<button
								className="items-center px-6 py-5 border border-transparent text-xl font-medium rounded-full w-full shadow-sm text-white my-6"
								type="submit"
								disabled={this.state.loading}
								style={{ backgroundColor: btnColor }}
							>
								{this.state.loading ? t.loading : t.continue}
							</button>
						</form>
						<p className="mb-5">
							<Link to="/connexion" className="font-semibold text-gray-400">
								{t.already_account_msg}
								<b className="font-semibold ml-2" style={{ color: themeColor }}>{t.already_account_action}</b>
							</Link>
						</p>
					</div>
				</div>
			</div>
		)
	}
}

export default SubscribeStepIdentity
